import React, { Fragment } from 'react';
import classNames from 'classnames';
import { Checkbox, Comment, ErrorMessage, hoc } from 'src/core';
import {
  CheckboxRadioListItemWrapper,
  CheckboxRadioListWrapper
} from '../shared';
import { useCheckboxQuestionProps } from './checkbox-question.props';
import styles from './checkbox-question.module.scss';

/**
 * <CheckboxQuestion />
 */
const CheckboxQuestion = hoc(
  useCheckboxQuestionProps,
  ({
    isBigList,
    isError,
    value,
    question,
    error,
    filteredList,
    commentValues,
    valuesWithComment,
    valuesWithoutComment,
    isLimitElementsMaxError,
    limitElementsMaxMessage,
    onCommentChange,
    onCheckboxClick
  }) =>
    value !== 'string' ? (
      <Fragment>
        <CheckboxRadioListWrapper>
          {filteredList.map(
            ({ text, label, exclusive, comment, imageUrl }, index) => {
              const values = comment ? valuesWithComment : valuesWithoutComment;
              const checked = values.includes(text);

              return (
                <>
                  {!!label ? (
                    <p className={styles.title}>{label}</p>
                  ) : (
                    <CheckboxRadioListItemWrapper
                      key={index}
                      onCheckboxRadioClick={() =>
                        onCheckboxClick(text, { exclusive, comment })
                      }
                      isImageUrl={filteredList.some(({ imageUrl }) => imageUrl)}
                      commentVal={comment}
                      comment={
                        <React.Fragment>
                          {comment && (
                            <Comment
                              name={text}
                              value={
                                commentValues.find(
                                  ({ answer }) => answer === text
                                )?.comment ?? ''
                              }
                              onChange={event =>
                                onCommentChange(
                                  event.target.name,
                                  event.target.value
                                )
                              }
                              disabled={!checked}
                            />
                          )}
                        </React.Fragment>
                      }
                    >
                      <Checkbox
                        classes={{
                          flag: classNames(
                            isBigList && styles.checkbox__small_flag
                          ),
                          label: classNames(
                            isBigList && styles.checkbox__small_font
                          )
                        }}
                        question={question}
                        label={text}
                        image={imageUrl}
                        value={checked}
                        onChange={() => {}}
                        isError={isError}
                        error={error}
                      />
                    </CheckboxRadioListItemWrapper>
                  )}
                </>
              );
            }
          )}
        </CheckboxRadioListWrapper>
        <ErrorMessage
          isError={isError || isLimitElementsMaxError}
          error={
            isError
              ? error
              : isLimitElementsMaxError
              ? limitElementsMaxMessage
              : error
          }
        />{' '}
      </Fragment>
    ) : null
);

export { CheckboxQuestion };
